/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AmountInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function AmountInput({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsRequestPayment/Content/AmountInput",
  onChange,
  isInvalid,
  isSubmitting
  
}) {
let paymentsRequestPaymentAmountValueData = fromData.useDataValue({ viewPath,
context: 'payments_request_payment',
path: 'amount',
})
let paymentsRequestPaymentAmountIsValidData = fromData.useDataIsValid({ viewPath,
context: 'payments_request_payment',
path: 'amount',
validate: fromValidate.validateCurrency,
required: true,
})
let paymentsRequestPaymentAmountChangeData = fromData.useDataChange({ viewPath,
context: 'payments_request_payment',
path: 'amount',
})
let paymentsRequestPaymentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payments_request_payment',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 data="payments_request_payment.amount"
 validate="/Data/validate.js validateCurrency"
 required={true}
 value={paymentsRequestPaymentAmountValueData}
 onChange={paymentsRequestPaymentAmountChangeData}
 invalid={!paymentsRequestPaymentAmountIsValidData}
 data="payments_request_payment"
 disabled={paymentsRequestPaymentIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Amount"
 weight="medium"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 backgroundColor={dtColorsWhite}
 borderColor={dtColorsNeutral300}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="currency"
 placeholder="$0.00"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}